/* Wine with Time — Custom Theme JS */

/* ── Transparante header: gesatineerd na scrollen ────────── */
function initStickyHeader() {
  const headerGroup = document.getElementById('header-group');
  if (!headerGroup) return;

  const onScroll = () => {
    headerGroup.classList.toggle('header--scrolled', window.scrollY > 10);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

/* ── Age verification ─────────────────────────────────────── */
function initAgeVerification() {
  const gate = document.getElementById('age-verification');
  if (!gate) return;

  if (sessionStorage.getItem('age-verified') === 'true') {
    gate.classList.add('is-hidden');
    return;
  }

  document.body.classList.add('age-gate-open');

  document.getElementById('age-gate-yes').addEventListener('click', () => {
    sessionStorage.setItem('age-verified', 'true');
    gate.classList.add('is-hidden');
    document.body.classList.remove('age-gate-open');
  });

  document.getElementById('age-gate-no').addEventListener('click', () => {
    window.location.href = 'https://www.ik-ben-minderjarig.nl/';
  });
}

/* ── Wijn archief filter ──────────────────────────────────── */
function initWijnFilter() {
  const buttons = document.querySelectorAll('.wijn-filter-btn');
  const cards = document.querySelectorAll('.wijn-card');

  if (!buttons.length) return;

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const filter = btn.dataset.filter;

      buttons.forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');

      cards.forEach((card) => {
        const match = filter === 'all' || card.dataset.type.includes(filter);
        card.style.display = match ? '' : 'none';
      });
    });
  });
}

/* ── Account: view switching & password toggle ───────────── */
function initAccountForms() {
  // View switcher (login / register / reset)
  document.querySelectorAll('[data-show]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.show;
      ['login-view', 'register-view', 'reset-view'].forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.style.display = id === target ? '' : 'none';
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  // Show URL hash on load (e.g. /account/login#recover)
  if (window.location.hash === '#recover') {
    const resetView = document.getElementById('reset-view');
    const loginView = document.getElementById('login-view');
    if (resetView && loginView) {
      loginView.style.display = 'none';
      resetView.style.display = '';
    }
  }

  // Password show/hide toggle
  document.querySelectorAll('.account-toggle-password').forEach((btn) => {
    btn.addEventListener('click', () => {
      const wrap  = btn.closest('.account-input-wrap');
      const input = wrap.querySelector('input');
      const show  = wrap.querySelector('.icon-eye-show');
      const hide  = wrap.querySelector('.icon-eye-hide');
      const isPassword = input.type === 'password';
      input.type = isPassword ? 'text' : 'password';
      show.style.display = isPassword ? 'none' : '';
      hide.style.display = isPassword ? '' : 'none';
    });
  });
}

/* ── Box archief jaarfilter ──────────────────────────────── */
function initArchiveFilter() {
  const btns  = document.querySelectorAll('.arch-filter-btn');
  const cards = document.querySelectorAll('.arch-box-card');
  if (!btns.length) return;

  btns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const year = btn.dataset.year;
      btns.forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      cards.forEach((card) => {
        const match = year === 'all' || card.dataset.year === year;
        card.classList.toggle('is-hidden', !match);
      });
    });
  });
}

/* ── Evenementen reserveringsmodal ───────────────────────── */
function initEventModal() {
  const modal    = document.getElementById('ev-modal');
  const closeBtn = document.getElementById('ev-modal-close');
  if (!modal) return;

  const eventInfo  = document.getElementById('ev-modal-event-info');
  const inputName  = document.getElementById('ev-form-event-name');
  const inputDate  = document.getElementById('ev-form-event-date');

  function openModal(btn) {
    const title = btn.dataset.eventTitle || '';
    const date  = btn.dataset.eventDate  || '';
    const time  = btn.dataset.eventTime  || '';
    const price = btn.dataset.eventPrice || '';

    if (inputName) inputName.value = title;
    if (inputDate) inputDate.value = date;
    if (eventInfo) eventInfo.textContent = [title, date, time, price].filter(Boolean).join(' · ');

    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    modal.querySelector('.ev-modal-close').focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.ev-reserve-btn:not([disabled])').forEach((btn) => {
    btn.addEventListener('click', () => openModal(btn));
  });

  closeBtn.addEventListener('click', closeModal);

  modal.querySelector('.ev-modal-backdrop').addEventListener('click', closeModal);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initStickyHeader();
  initAgeVerification();
  initAccountForms();
  initWijnFilter();
  initEventModal();
  initArchiveFilter();
});
